function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import classnames from 'classnames';
import React, { useRef, useState, useEffect } from 'react';
import FocusLock from 'react-focus-lock';
import { Transition } from 'react-transition-group';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import { DialogSizes, DialogTypes, DialogAnimations, DrawerAnimations } from "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import "../../../../utilities/color.js";
import 'date-fns';
import "../../../../utilities/locale.js";
import { usePrefersReducedMotion } from "../../../../hooks/use-prefers-reduced-motion.js";
import "../../../../hooks/use-prevent-keyboard-scrolling.js";
import "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import 'styled-components';
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import "../../../../styles/styled-components/tooltip.js";
import { transitionFadeIn } from "../../../../styles/transitions/fade-in.js";
import { transitionFadeInFromBottom } from "../../../../styles/transitions/fade-in-from-bottom.js";
import { transitionFadeInFromLeft } from "../../../../styles/transitions/fade-in-from-left.js";
import { transitionFadeInFromRight } from "../../../../styles/transitions/fade-in-from-right.js";
import { transitionFadeInFromTop } from "../../../../styles/transitions/fade-in-from-top.js";
import { Dialog } from "./components/dialog.js";
import { DialogBackground } from "./components/dialog-background.js";
import { DialogBody } from "./components/dialog-body.js";
import { DialogFooter } from "./components/dialog-footer.js";
import { DialogHeader } from "./components/dialog-header.js";
import { DialogInner } from "./components/dialog-inner.js";
import { DialogOverlay } from "./components/dialog-overlay.js";
import { DialogType } from "./components/dialog-type.js";
import { DialogWrapper } from "./components/dialog-wrapper.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
/**
 * An accessible dialog component for creating modals or drawers.
 * A dialog should only be used when we need to stop the user from interacting with the rest of the application
 * (think hard about this as it has accessibility implications... don't use a dialog if at all possible).
 * Accessibility requirements can be found at https://www.w3.org/TR/wai-aria-practices-1.2/#dialog_modal
 * @param {BaseDialogProps} props BaseDialogProps
 */
var BaseDialog = function BaseDialog(props) {
  var animation = props.animation,
    _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
    beforeClose = props.beforeClose,
    children = props.children,
    className = props.className,
    _props$closeOnBackgro = props.closeOnBackgroundClick,
    closeOnBackgroundClick = _props$closeOnBackgro === void 0 ? true : _props$closeOnBackgro,
    contentCentered = props.contentCentered,
    dialogBackgroundProps = props.dialogBackgroundProps,
    dialogBodyProps = props.dialogBodyProps,
    dialogFooterProps = props.dialogFooterProps,
    dialogHeaderProps = props.dialogHeaderProps,
    dialogInnerProps = props.dialogInnerProps,
    dialogOverlayProps = props.dialogOverlayProps,
    dialogProps = props.dialogProps,
    dialogTypeProps = props.dialogTypeProps,
    dialogWrapperProps = props.dialogWrapperProps,
    _props$focusLock = props.focusLock,
    focusLock = _props$focusLock === void 0 ? true : _props$focusLock,
    focusLockProps = props.focusLockProps,
    footer = props.footer,
    header = props.header,
    height = props.height,
    id = props.id,
    labels = props.labels,
    loading = props.loading,
    next = props.next,
    onClose = props.onClose,
    open = props.open,
    prev = props.prev,
    setOpen = props.setOpen,
    _props$showClose = props.showClose,
    showClose = _props$showClose === void 0 ? true : _props$showClose,
    _props$showFooter = props.showFooter,
    showFooter = _props$showFooter === void 0 ? true : _props$showFooter,
    _props$showTitle = props.showTitle,
    showTitle = _props$showTitle === void 0 ? true : _props$showTitle,
    _props$size = props.size,
    size = _props$size === void 0 ? DialogSizes.Auto : _props$size,
    title = props.title,
    titleIcon = props.titleIcon,
    _props$transitionDela = props.transitionDelay,
    transitionDelay = _props$transitionDela === void 0 ? 0 : _props$transitionDela,
    _props$transitionDura = props.transitionDuration,
    transitionDuration = _props$transitionDura === void 0 ? 300 : _props$transitionDura,
    _props$type = props.type,
    type = _props$type === void 0 ? DialogTypes.Modal : _props$type,
    width = props.width;
  var closeButtonLabel = labels.closeButtonLabel,
    loaderLabel = labels.loaderLabel;
  var prefersReducedMotion = usePrefersReducedMotion();
  var nodeRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMounted = _useState2[0],
    setIsMounted = _useState2[1];
  /**
  * toggles "dialog-open" CSS class, which is needed to add overflow: hidden on the body element.
  * This prevents vertical scrolling and makes background content inert in accordance with w3c guidelines.
  * https://www.w3.org/TR/wai-aria-practices-1.2/#dialog_modal
  * @returns {void} void
  */ // eslint-disable-next-line unicorn/consistent-function-scoping
  var updateBodyClass = function updateBodyClass(action) {
    var body = document.querySelectorAll('body');
    if (body.length > 0 && action === 'close' && body[0].classList.contains('dialog-open')) {
      body[0].classList.remove('dialog-open');
    }
    if (body.length > 0 && action === 'open' && !body[0].classList.contains('dialog-open')) {
      body[0].classList.add('dialog-open');
    }
  };
  /**
  * Closes, the dialog, removes "dialog-open" CSS class and calls the onClose callback.
  * @returns {void} void
  */
  var close = function close() {
    // setOpen should be first
    setOpen(false);
    if (onClose) {
      onClose();
    }
    updateBodyClass('close');
  };
  /**
  * If beforeClose is passed as a prop, closes the dialog only if it returns true.
  * @returns {void} void
  */
  var handleClose = function handleClose(forceClose) {
    if (beforeClose && !forceClose) {
      var shouldClose = beforeClose();
      if (shouldClose) {
        close();
      }
    } else {
      close();
    }
  };
  /**
  * It is required dialogs should close on escape. DO NOT REMOVE.
  * https://www.w3.org/TR/wai-aria-practices-1.2/#dialog_modal
  * @param {KeyboardEvent} e KeyboardEvent
  * @returns {void} void
  */
  var handleCloseOnEsc = function handleCloseOnEsc(e) {
    if (e.key === 'Escape') {
      handleClose();
    }
  };
  useEffect(function () {
    // DO NOT REMOVE
    setIsMounted(true); // ensures component is mounted before enabling CSSTransition, otherwise CSSTransition classes are not added correctly
    window.addEventListener('keyup', handleCloseOnEsc);
    return function () {
      window.removeEventListener('keyup', handleCloseOnEsc);
      handleClose();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    if (open) {
      updateBodyClass('open');
    }
    if (!open && isMounted) {
      handleClose(true);
    }
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  var ariaLabelledBy = "".concat(id, "-label");
  var animate = animation || (type === DialogTypes.Modal ? DialogAnimations.FadeInFromTop : DrawerAnimations.FadeInFromRight);
  var timeout = transitionDelay ? transitionDelay + transitionDuration : transitionDuration;
  var renderInner = function renderInner() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, !!prev && prev, /*#__PURE__*/React.createElement(DialogInner, _extends({}, dialogInnerProps), /*#__PURE__*/React.createElement(DialogHeader, _extends({}, dialogHeaderProps, {
      closeButtonLabel: closeButtonLabel,
      handleClose: handleClose,
      id: ariaLabelledBy,
      showClose: showClose,
      showTitle: showTitle,
      title: title,
      titleIcon: titleIcon
    }), header), /*#__PURE__*/React.createElement(DialogBody, _extends({}, dialogBodyProps, {
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus: autoFocus,
      contentCentered: contentCentered,
      loaderLabel: loaderLabel,
      loading: loading
    }), children), showFooter && /*#__PURE__*/React.createElement(DialogFooter, _extends({}, dialogFooterProps), footer)), !!next && next);
  };
  return /*#__PURE__*/React.createElement(Transition, {
    appear: isMounted && open,
    in: isMounted && open,
    mountOnEnter: true,
    nodeRef: nodeRef,
    timeout: timeout,
    unmountOnExit: true
  }, function (transitionStatus) {
    var _classnames;
    return /*#__PURE__*/React.createElement(Dialog, _extends({}, dialogProps, {
      className: classnames((_classnames = {}, _defineProperty(_classnames, "".concat(className), !!className), _defineProperty(_classnames, "".concat(dialogProps === null || dialogProps === void 0 ? void 0 : dialogProps.className), !!(dialogProps !== null && dialogProps !== void 0 && dialogProps.className)), _classnames)),
      ref: nodeRef
    }), /*#__PURE__*/React.createElement(DialogWrapper, _extends({}, dialogWrapperProps), /*#__PURE__*/React.createElement(DialogType, _extends({}, dialogTypeProps, {
      animation: animate,
      "aria-labelledby": ariaLabelledBy,
      height: height,
      id: id,
      size: size,
      style: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, dialogTypeProps === null || dialogTypeProps === void 0 ? void 0 : dialogTypeProps.style), !prefersReducedMotion && animate === DialogAnimations.FadeIn && transitionFadeIn({
        transitionDelay: transitionDelay,
        transitionDuration: transitionDuration,
        transitionStatus: transitionStatus
      })), !prefersReducedMotion && animate === DialogAnimations.FadeInFromBottom && transitionFadeInFromBottom({
        transitionDelay: transitionDelay,
        transitionDuration: transitionDuration,
        transitionStatus: transitionStatus
      })), !prefersReducedMotion && animate === DialogAnimations.FadeInFromLeft && transitionFadeInFromLeft({
        transitionDelay: transitionDelay,
        transitionDuration: transitionDuration,
        transitionStatus: transitionStatus
      })), !prefersReducedMotion && animate === DialogAnimations.FadeInFromRight && transitionFadeInFromRight({
        transitionDelay: transitionDelay,
        transitionDuration: transitionDuration,
        transitionStatus: transitionStatus
      })), !prefersReducedMotion && animate === DialogAnimations.FadeInFromTop && transitionFadeInFromTop({
        transitionDelay: transitionDelay,
        transitionDuration: transitionDuration,
        transitionStatus: transitionStatus
      })),
      type: type,
      width: width
    }), focusLock ? /*#__PURE__*/React.createElement(FocusLock, _extends({}, focusLockProps, {
      className: classnames(_defineProperty({
        'bf-dialog__focus-lock': true
      }, "".concat(focusLockProps === null || focusLockProps === void 0 ? void 0 : focusLockProps.className), !!(focusLockProps !== null && focusLockProps !== void 0 && focusLockProps.className))),
      crossFrame: (focusLockProps === null || focusLockProps === void 0 ? void 0 : focusLockProps.crossFrame) || false
    }), renderInner()) : renderInner()), closeOnBackgroundClick && /*#__PURE__*/React.createElement(DialogBackground, _extends({}, dialogBackgroundProps, {
      handleClose: handleClose,
      id: id
    }))), /*#__PURE__*/React.createElement(DialogOverlay, _extends({}, dialogOverlayProps, {
      size: size,
      style: _objectSpread(_objectSpread({}, dialogOverlayProps === null || dialogOverlayProps === void 0 ? void 0 : dialogOverlayProps.style), !prefersReducedMotion && transitionFadeIn({
        transitionDelay: transitionDelay,
        transitionDuration: transitionDuration,
        transitionStatus: transitionStatus
      }))
    })));
  });
};
export { BaseDialog };